export default __webpack_public_path__ + "static/media/thumbnail.fd0723e8.webp";